import * as THREE from 'three'

let Triangle = new THREE.BufferGeometry();

Triangle.addAttribute( 'position',  new THREE.Float32BufferAttribute( new Float32Array(
    [
       -1, -1, 0, 
      -1,  4, 0, 
       4, -1, 0
    ]
), 3 ));

Triangle.attributes.position.needsUpdate = true

Triangle.setIndex( new THREE.BufferAttribute( new Uint16Array( [0, 1, 2] ), 1 ) );

Triangle.index.needsUpdate = true

Triangle.needsUpdate = true

export default Triangle;


// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/triangle.js